import { render } from "./SeriesHeader.vue?vue&type=template&id=2a7538fb"
import script from "./SeriesHeader.vue?vue&type=script&lang=js"
export * from "./SeriesHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__